export default __webpack_public_path__ + "static/hotblack-tech-about4-45917e8b0137ea334365866a8113854e.svg";